<template>
    <div class="payover">
        <div class="evaluation">
            企业能耗成本
        </div>
        <div class="content">
            <div class="tab">
                <span :class="tabIdx == 0?'se':''" @click="tab(0)">月</span>
                <span :class="tabIdx == 1?'se':''" @click="tab(1)">年</span>
            </div>
            <div class="con" v-for="item in energyList" :key="item.id">
                <div class="title">本{{tabIdx == 0?'月' + item.title:'年' + item.title }}</div>
                <div :class="item.value == '--'?'price grey':'price' " >{{item.value}} <span v-show="item.value !== '--'">{{item.unit}}</span></div>
            </div>
        </div>
        <div class="evaluation">
            租户能耗成本
        </div>
        <div class="content">
            <div class="tab">
                <span :class="tabIdx == 0?'se':''" @click="tab(0)">月</span>
                <span :class="tabIdx == 1?'se':''" @click="tab(1)">年</span>
            </div>
            <div class="con" v-for="item in payList" :key="item.id">
                <div class="title">本{{tabIdx == 0?'月' + item.title:'年' + item.title }}</div>
                <div :class="item.value == '--'?'price grey':'price' ">{{item.value}} <span v-show="item.value !== '--'">{{item.unit}}</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import {getOperationEnergy, getTypePrice} from '../../../api/power'
import {dayStart} from '../../../util/DateUtil'

export default {
  data() {
    return {
      tabIdx: 0,
      energyList: [
        {
          id: 1,
          title: '用电成本',
          value: '--',
          unit: '￥'
        },
        {
          id: 2,
          title: '用水成本',
          value: '--',
          unit: '￥'
        },
        {
          id: 3,
          title: '用气成本',
          value: '--',
          unit: '￥'
        },
        {
          id: 4,
          title: '用电度数',
          value: '--',
          unit: 'kWh'
        },
        {
          id: 5,
          title: '用水吨数',
          value: '--',
          unit: 't'
        },
        {
          id: 6,
          title: '用气立方',
          value: '--',
          unit: 'm³'
        },
      ],
      payList: [
        {
          id: 1,
          title: '用电成本',
          value: '--',
          unit: '￥'
        },
        {
          id: 2,
          title: '用水成本',
          value: '--',
          unit: '￥'
        },
        {
          id: 3,
          title: '用气成本',
          value: '--',
          unit: '￥'
        },
        {
          id: 4,
          title: '用电度数',
          value: '--',
          unit: 'kWh'
        },
        {
          id: 5,
          title: '用水吨数',
          value: '--',
          unit: 't'
        },
        {
          id: 6,
          title: '用气立方',
          value: '--',
          unit: 'm³'
        },
      ],
      monthArr: {
        firm: {
          power: 0,
          water: 0,
          gas: 0,
        },
        tenant: {
          power: 0,
          water: 0,
          gas: 0
        }
      },
      yearArr: {
        firm: {
          power: 0,
          water: 0,
          gas: 0,
        },
        tenant: {
          power: 0,
          water: 0,
          gas: 0,
        }
      },
      priceGroup: {
        energy: 1,
        gas: 1,
        water: 1
      }
    }
  },
  watch: {},
  mounted() {

    this.getList()
  },
  methods: {
    tab(idx) {
      let _this = this
      this.tabIdx = idx
      let current = {}
      let currentT = {}
      switch (idx) {
        case 0 :
          current = this.monthArr.firm
          currentT = this.monthArr.tenant
          break;
        case 1 :
          current = this.yearArr.firm
          currentT = this.yearArr.tenant
          break;
      }
      _this.$set(_this.energyList[0], 'value', current.power == '--' ? '--' : Number(current.powerCost).toFixed(2))
      _this.$set(_this.energyList[1], 'value', current.water == '--' ? '--' : Number(current.waterCost).toFixed(2))
      _this.$set(_this.energyList[2], 'value', current.gas == '--' ? '--' : Number(current.gasCost).toFixed(2))
      _this.$set(_this.energyList[3], 'value', current.power == '--' ? '--' : Number(current.power).toFixed(2))
      _this.$set(_this.energyList[4], 'value', current.water == '--' ? '--' : Number(current.water).toFixed(2))
      _this.$set(_this.energyList[5], 'value', current.gas == '--' ? '--' : Number(current.gas).toFixed(2))

      _this.$set(_this.payList[0], 'value', currentT.power == '--' ? '--' : Number(currentT.powerCost).toFixed(2))
      _this.$set(_this.payList[1], 'value', currentT.water == '--' ? '--' : Number(currentT.waterCost).toFixed(2))
      _this.$set(_this.payList[2], 'value', currentT.gas == '--' ? '--' : Number(currentT.gasCost).toFixed(2))
      _this.$set(_this.payList[3], 'value', currentT.power == '--' ? '--' : Number(currentT.power).toFixed(2))
      _this.$set(_this.payList[4], 'value', currentT.water == '--' ? '--' : Number(currentT.water).toFixed(2))
      _this.$set(_this.payList[5], 'value', currentT.gas == '--' ? '--' : Number(currentT.gas).toFixed(2))

      let val = current.power == '--' ? 0 : Number(current.powerCost).toFixed(2)
      let val1 = current.water == '--' ? 0 : Number(current.waterCost).toFixed(2)
      let val2 = current.gas == '--' ? 0 : Number(current.gasCost).toFixed(2)
      let val3 = currentT.power == '--' ? 0 : Number(currentT.powerCost).toFixed(2)
      let val4 = currentT.water == '--' ? 0 : Number(currentT.waterCost).toFixed(2)
      let val5 = currentT.gas == '--' ? 0 : Number(currentT.gasCost).toFixed(2)

      let group = {
        firm: Number(val) + Number(val1) + Number(val2),
        tenant: Number(val3) + Number(val4) + Number(val5)
      }
      this.$store.commit('getCostOperation', group)
    },
    async getList() {
      let today = dayStart(new Date())
      // console.log(today);
      let res = await getOperationEnergy({
        date: today,
        projectId: this.$store.getters.projectId,
        range: 'month'
      })

      let res1 = await getOperationEnergy({
        date: today,
        projectId: this.$store.getters.projectId,
        range: 'year'
      })
      // console.log(res);
      if (res.data.code == 200) {
        this.monthArr = res.data.data
        this.tab(0)
      } else {
        console.log('err:' + res.data.errMsg);
        this.tab(0)
        let group = {
          firm: 0,
          tenant: 0
        }

        this.$store.commit('getCostOperation', group)
      }

      if (res1.data.code == 200) {
        this.yearArr = res1.data.data

      } else {
        console.log('err:' + res1.data.errMsg);
      }
    },

  }
}
</script>

<style lang="less" scoped>
.payover {
  .evaluation {
    height: 3.5vh;
    padding-top: 12rem;
    padding-left: 13rem;
    line-height: 28rem;
    box-sizing: border-box;
    font-size: 16rem;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    position: relative;

    &::before {
      content: '';
      width: 5rem;
      height: 18rem;
      background: #0D94FF;
      position: absolute;
      left: 0;
      top: 17.5rem;
    }
  }

  .content {
    height: 20.2vh;
    border-top: 1px solid rgba(0, 0, 0, 0.15);
    background: rgba(0, 43, 102, 0.04);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    align-content: space-evenly;
    position: relative;
    padding: 0 16rem;
    padding-top: 2vh;

    .con {
      width: 33%;

      .title {
        font-size: 16rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
      }

      .price {
        font-size: 24rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #0D94FF;
        padding-top: 0.5vh;

        & > span {
          font-size: 16rem;
        }
      }
    }

    .con:nth-child(5), .con:nth-child(6), .con:nth-child(7) {
      .price {
        font-size: 18rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #0D94FF;
        padding-top: 0.5vh;

        & > span {
          font-size: 14rem;
        }
      }
    }

    &::before {
      content: '';
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.06);
      position: absolute;
      top: calc(50% + 1vh);
      left: 0;
    }

    .tab {
      height: 34rem;
      line-height: 34rem;
      font-size: 16rem;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      flex-direction: row-reverse;

      & > span {
        margin-right: 15rem;
        display: inline-block;
        border-top: 2px solid rgba(0, 0, 0, 0);
        cursor: pointer;
      }

      .se {
        border-top: 2px solid #409EFF;
        color: #0D94FF;
      }
    }
  }

}
</style>